import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

interface LoginScreenProps {
  onLogin: (password: string) => void;
  error?: string;
}

const LoginScreen: React.FC<LoginScreenProps> = ({ onLogin, error }) => {
  const [password, setPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onLogin(password);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--color-background)',
        padding: 'var(--space-xl)',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 'var(--space-xl)',
          borderRadius: 'var(--radius-lg)',
          width: '100%',
          maxWidth: '400px',
          backgroundColor: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
        }}
      >
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--space-lg)',
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <LockIcon
              sx={{
                fontSize: 48,
                color: 'var(--color-primary)',
                marginBottom: 'var(--space-md)',
              }}
            />
            <Typography
              variant="h5"
              sx={{
                color: 'var(--color-text)',
                fontWeight: 600,
                marginBottom: 'var(--space-xs)',
              }}
            >
              Meeting Categorizer
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'var(--color-text-secondary)' }}
            >
              Enter the password to continue
            </Typography>
          </Box>

          <TextField
            fullWidth
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!error}
            helperText={error}
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                '& fieldset': {
                  borderColor: 'var(--color-border)',
                },
                '&:hover fieldset': {
                  borderColor: 'var(--color-primary)',
                },
              },
              '& .MuiOutlinedInput-input': {
                color: 'var(--color-text)',
              },
            }}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: 'var(--color-primary)',
              color: 'var(--color-text)',
              padding: 'var(--space-md)',
              borderRadius: 'var(--radius-full)',
              textTransform: 'none',
              fontWeight: 500,
              '&:hover': {
                backgroundColor: 'var(--color-primary)',
                opacity: 0.9,
              },
            }}
          >
            Continue
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default LoginScreen; 